export const CMDRestWebParamTableColumns = [
  {
    key: "name",
    display_name: "Name",
    cellStyles: {
      "font-size": "12px",
    },
    headerStyles: {
      background: "#7593F2",
      width: "30%",
      borderRadius: "6px 0 0",
      color: "#fff",
      'font-size': '12px !important'
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Add key'
    }
  },
  {
    key: "value",
    display_name: "Value",
    cellStyles: { "font-size": "12px" },
    headerStyles: {
      background: "#7593F2",
      width: "20%",
      color: "#fff",
      'font-size': '12px !important'
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Add value',
      isAutoCompleteEnable: true
    }
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "12px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/edit-light.svg",
      isClickable: "true",
      actionType:"edit",
    },
    _editConfig: {
      type: "svg-editor",
      actionType:"add",
      value: "../../../../assets/images/virtusa-icons/tick.svg",
      isClickable: "true",
    }
  },
  {
    key: "delete",
    display_name: "",
    cellStyles: { "font-size": "12px" },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/delete-light.svg",
      isClickable: "true",
      actionType:"delete",
    },
    _editConfig: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/cross.svg",
      isClickable: "true",
      actionType:"cancel",
    }
  },
];


export const CMDRestWebHeaderTableColumns = [
  {
    key: "key",
    display_name: "Key",
    cellStyles: {
      "font-size": "12px",
    },
    headerStyles: {
      background: "#7593F2",
     'font-size': '12px !important',
      width: "30%",
      borderRadius: "6px 0 0",
      color: "#fff",
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Add key'
    }
  },
  {
    key: "value",
    display_name: "Value",
    cellStyles: { "font-size": "12px" },
    headerStyles: {
      background: "#7593F2",
      'font-size': '12px !important',
      width: "20%",
      color: "#fff",
    },
    _editConfig: {
      type: 'input',
      placeholder: 'Add value',
      isAutoCompleteEnable: true
    }
  },
  {
    key: "edit",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/edit-light.svg",
      isClickable: "true",
      actionType:"edit",
    },
    _editConfig: {
      type: "svg-editor",
      actionType:"add",
      value: "../../../../assets/images/virtusa-icons/tick.svg",
      isClickable: "true",
    }
  },
  {
    key: "delete",
    display_name: "",
    cellStyles: { "font-size": "13px" },
    headerStyles: {
      background: "#7593F2",
      borderRadius: "0 6px 0 0",
      "font-weight": "600",
      width: "3%",
      color: "#fff",
    },
    _config: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/delete-light.svg",
      isClickable: "true",
      actionType:"delete",
    },
    _editConfig: {
      type: "svg-editor",
      value: "../../../../assets/images/virtusa-icons/cross.svg",
      isClickable: "true",
      actionType:"cancel",
    }
  },
];
